var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"paybright pointer",on:{"click":_vm.showModal}},[_c('span',{staticClass:"paybright-as-low-as pb-price",attrs:{"id":"paybright-widget-container","data-amount":_vm.amount}})])}
var staticRenderFns = []

export { render, staticRenderFns }